module.exports = "pegasus_template/assets/film-card.png";